const configuration = {
  SERVER_PORT: import.meta.env.VITE_SERVER_PORT,
  GATEWAY_API_HOST: import.meta.env.VITE_GATEWAY_API_HOST,
  AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  IS_IN_PRODUCTION: import.meta.env.PROD,
  REPORT_API_HOST: import.meta.env.VITE_REPORT_API_HOST,
  CCEE_API_HOST: import.meta.env.VITE_CCEE_API_HOST,
};

if (!configuration.GATEWAY_API_HOST) {
  throw `Invalid GATEWAY_API_HOST! value found: ${configuration.GATEWAY_API_HOST}`;
}

export default configuration;
